import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import routes from './routes/routes';
import "./components/traduction/i18n"
import { scrollToTop } from './lib/utils';
import "react-toastify/dist/ReactToastify.css";

const App: React.FC = () => {

  useEffect(() => {
    scrollToTop()
  }, [])

  return (
    <Router>
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element}>
            {route.children?.map((childRoute, childIndex) => (
              <Route
                key={childIndex}
                path={childRoute.path}
                element={childRoute.element}
              />

            ))}
          </Route>
        ))}
      </Routes>
    </Router>
  );
}

export default App;